"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['pageId'],
  data: function data() {
    return {
      sonCode: '',
      sonList: [],
      type: '',
      id: '',
      dialogVisible1: false,
      popTitle: '',
      ruleForm: {
        moduleVal: ''
      },
      options: [],
      rules: {
        moduleVal: [{
          required: true,
          message: '请选择模块',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    open: function open(data) {
      var _this = this;
      (0, _customPage.queryComponent)({
        pageType: 1
      }).then(function (res) {
        _this.options = res.data;
      });
      this.dialogVisible1 = true;
    },
    sonClick: function sonClick(val) {
      this.sonCode = val.componentCode;
    },
    onClose: function onClose() {
      this.ruleForm = {};
      this.$refs['ruleForm'].resetFields();
      this.sonList = [];
      this.sonCode = '';
      this.dialogVisible1 = false;
    },
    changeIt: function changeIt() {
      var _this2 = this;
      if (this.ruleForm.moduleVal) {
        (0, _customPage.querySubComponent)({
          componentCode: this.ruleForm.moduleVal,
          pageType: 1
        }).then(function (res) {
          console.log(res);
          if (res.data && res.data.length > 0) {
            _this2.sonCode = res.data[0].componentCode;
            _this2.sonList = res.data;
          } else {
            _this2.sonList = [];
            _this2.sonCode = _this2.ruleForm.moduleVal;
          }
        });
      }
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log(_this3.$props.pageId, _this3.ruleForm.moduleVal, _this3.sonCode);
          var obj = {};
          if (_this3.ruleForm.moduleVal === _this3.sonCode) {
            obj = {
              componentCode: _this3.ruleForm.moduleVal,
              componentName: _this3.options.filter(function (i) {
                return i.componentCode === _this3.ruleForm.moduleVal;
              })[0].componentName
            };
          } else {
            obj = {
              componentCode: _this3.ruleForm.moduleVal,
              componentName: _this3.options.filter(function (i) {
                return i.componentCode === _this3.ruleForm.moduleVal;
              })[0].componentName,
              subComponentName: _this3.sonList.filter(function (i) {
                return i.componentCode === _this3.sonCode;
              })[0].componentName,
              subComponentCode: _this3.sonCode
            };
          }
          obj['pageId'] = _this3.$props.pageId * 1;
          (0, _customPage.saveModules)(obj).then(function (res) {
            if (res.data) {
              _this3.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this3.onClose();
              _this3.$emit('refresh');
            }
          });
          console.log(obj);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.sonList = [];
      this.sonCode = '';
    }
  }
};